// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_markConversationMessagesAsReadV5_ConversationMessagesMarkedAsRead_messages_status(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["IncomingMessageStatus"]);
}

function unwrap_response_markConversationMessagesAsReadV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["ConversationMessagesMarkedAsRead"]);
}

var variablesConverter = {"markConversationMessagesAsReadV5Input":{},"__root":{"input":{"r":"markConversationMessagesAsReadV5Input"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"markConversationMessagesAsReadV5_ConversationMessagesMarkedAsRead_messages_status":{"u":"response_markConversationMessagesAsReadV5_ConversationMessagesMarkedAsRead_messages_status"},"markConversationMessagesAsReadV5":{"u":"response_markConversationMessagesAsReadV5"}}};

var wrapResponseConverterMap = {
  response_markConversationMessagesAsReadV5_ConversationMessagesMarkedAsRead_messages_status: RescriptRelay_Internal.wrapUnion,
  response_markConversationMessagesAsReadV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"markConversationMessagesAsReadV5_ConversationMessagesMarkedAsRead_messages_status":{"u":"response_markConversationMessagesAsReadV5_ConversationMessagesMarkedAsRead_messages_status"},"markConversationMessagesAsReadV5":{"u":"response_markConversationMessagesAsReadV5"}}};

var responseConverterMap = {
  response_markConversationMessagesAsReadV5_ConversationMessagesMarkedAsRead_messages_status: unwrap_response_markConversationMessagesAsReadV5_ConversationMessagesMarkedAsRead_messages_status,
  response_markConversationMessagesAsReadV5: unwrap_response_markConversationMessagesAsReadV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function incomingMessageStatusState_decode($$enum) {
  if ($$enum === "PAST_MESSAGE" || $$enum === "NEW" || $$enum === "READ") {
    return $$enum;
  }
  
}

function incomingMessageStatusState_fromString(str) {
  return incomingMessageStatusState_decode(str);
}

var Utils = {
  incomingMessageStatusState_decode: incomingMessageStatusState_decode,
  incomingMessageStatusState_fromString: incomingMessageStatusState_fromString
};

var node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": "unreadMessages",
  "args": [
    {
      "kind": "Literal",
      "name": "readState",
      "value": "UNREAD"
    }
  ],
  "concreteType": "ConversationMessagesConnection",
  "kind": "LinkedField",
  "name": "messages",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": "messages(readState:\"UNREAD\")"
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        }
      ],
      "type": "IncomingMessageStatus",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "markConversationMessagesAsReadV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationV5",
                "kind": "LinkedField",
                "name": "conversation",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationMessageV5",
                "kind": "LinkedField",
                "name": "messages",
                "plural": true,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "ConversationMessagesMarkedAsRead",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "markConversationMessagesAsReadV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationV5",
                "kind": "LinkedField",
                "name": "conversation",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationMessageV5",
                "kind": "LinkedField",
                "name": "messages",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "ConversationMessagesMarkedAsRead",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "39f9996658f1077c1d00c3c41637eca7",
    "id": null,
    "metadata": {},
    "name": "ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation",
    "operationKind": "mutation",
    "text": "mutation ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation(\n  $input: MarkConversationMessagesAsReadV5Input!\n) {\n  markConversationMessagesAsReadV5(input: $input) {\n    __typename\n    ... on ConversationMessagesMarkedAsRead {\n      conversation {\n        unreadMessages: messages(readState: UNREAD) {\n          totalCount\n        }\n        nodeId\n      }\n      messages {\n        status {\n          __typename\n          ... on IncomingMessageStatus {\n            state\n          }\n        }\n        nodeId\n      }\n    }\n  }\n}\n"
  }
};
})());

var wrap_response_markConversationMessagesAsReadV5_ConversationMessagesMarkedAsRead_messages_status = RescriptRelay_Internal.wrapUnion;

var wrap_response_markConversationMessagesAsReadV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_markConversationMessagesAsReadV5_ConversationMessagesMarkedAsRead_messages_status = unwrap_response_markConversationMessagesAsReadV5_ConversationMessagesMarkedAsRead_messages_status;
exports.wrap_response_markConversationMessagesAsReadV5_ConversationMessagesMarkedAsRead_messages_status = wrap_response_markConversationMessagesAsReadV5_ConversationMessagesMarkedAsRead_messages_status;
exports.unwrap_response_markConversationMessagesAsReadV5 = unwrap_response_markConversationMessagesAsReadV5;
exports.wrap_response_markConversationMessagesAsReadV5 = wrap_response_markConversationMessagesAsReadV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
